<button mat-icon-button matSuffix class="mat-form-field-open-picker-button" (click)="$event.stopPropagation(); for.open();">
    <fa-icon class="icon" icon="palette"></fa-icon>
</button>
